import { Button, Space } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import AccessControlAction from '../../../components/AccessControlAction'
import { EmptyText } from '../../../components/Common/CellText'
import { StatusTag } from '../../../components/Common/StatusTag'
import { ACL_ACTION_TYPE, TYPE_STATUS, WORK_STATUS } from '../../../constants'
import WorkDetailCreateSubTaskModal from './WorkDetailCreateSubTaskModal'
import { SubWorkListItemStyled } from './WorkDetailV2Styled'

const WorkDetailSubTaskList = props => {
  const { workStore, setActiveTab } = props
  const history = useHistory()
  const { workDetail } = workStore || {}

  const [isOPenCreateSubTaskModal, setIsOPenCreateSubTaskModal] = useState(
    false
  )

  const handleOpenDetail = code => {
    history.push(`/works/view/${code}`)
    setActiveTab('1')
  }

  return (
    <div>
      <Space
        style={{
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 12,
        }}>
        <h3 style={{ marginBottom: 0, fontSize: 14, fontWeight: 600 }}>
          Công việc phụ
        </h3>
        {workDetail?.status !== WORK_STATUS.COMPLETE && (
          <AccessControlAction
            aclActionType={ACL_ACTION_TYPE.them_cong_viec_phu__WORK}>
            <Button
              type="primary"
              className="custom-ant-button"
              onClick={() => {
                setIsOPenCreateSubTaskModal(true)
              }}>
              Thêm công việc phụ
            </Button>
          </AccessControlAction>
        )}
      </Space>

      <div>
        {workDetail?.subwork?.length > 0 ? (
          workDetail?.subwork?.map(item => (
            <SubWorkListItemStyled
              key={item.code}
              onClick={() => handleOpenDetail(item?.code)}>
              <div>
                <p>{item?.title}</p>
                <span>{item?.updated_user}</span>
              </div>
              {StatusTag(TYPE_STATUS.WORK, item?.status)}
            </SubWorkListItemStyled>
          ))
        ) : (
          <EmptyText>Không có công việc phụ</EmptyText>
        )}
      </div>

      <WorkDetailCreateSubTaskModal
        isOpenModal={isOPenCreateSubTaskModal}
        setIsOpenModal={setIsOPenCreateSubTaskModal}
        parentCode={workDetail?.code}
      />
    </div>
  )
}

export default inject(
  'workStore',
  'fileStore',
  'loadingAnimationStore',
  'aclStore'
)(observer(WorkDetailSubTaskList))
